module.exports = __webpack_public_path__ + "static/img/336.c2826c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/201206/336.jpg
// module id = KB71
// module chunks = 0